import { useEffect, useState } from 'react';
import axios from 'axios';
import { API_URL } from '../config';
import { getToken } from '../utils/auth';

export function useNexoAcesso(identidade: string): boolean {
  const [permitido, setPermitido] = useState(false);
  useEffect(() => {
    const controller = new AbortController();
    setPermitido(false);
    const conferir = async () => {
      try {
        const token = await getToken();
        if (!token || controller.signal.aborted) return;
        const { data } = await axios.get(`${API_URL}/admin/nexo`, {
          params: { action: 'acesso' }, headers: { Authorization: token }, signal: controller.signal,
        });
        if (!controller.signal.aborted) setPermitido(data.permitido === true);
      } catch {
        if (!controller.signal.aborted) setPermitido(false);
      }
    };
    void conferir();
    window.addEventListener('focus', conferir);
    return () => { controller.abort(); window.removeEventListener('focus', conferir); };
  }, [identidade]);
  return permitido;
}
